module.exports = __webpack_public_path__ + "img/no-food-2.f96fa52e.jpeg";